import React from 'react';
import { Row, DirectionsLink, ArrowIconWrap, ExternalIconWrap } from './StyledGetDirectionsLink';
import { Directions, External } from '_utils/icons';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const GetDirectionsLink = (props) => {
  const [t] = useTranslation();
  const { latitude, longitude, googleListing } = props?.fields;
  let directionsUrl = '';

  const lat = latitude?.value;
  const lng = longitude?.value;
  const googleListingUrl = googleListing?.value?.href;

  const validGetDirURL =
    lat && lng ? `https://www.google.com/maps?saddr=My+Location&daddr=${lat},${lng}` : null; // If lat & lng concat with a comma

  if (validGetDirURL) {
    directionsUrl = validGetDirURL;
  } else if (googleListingUrl) {
    directionsUrl = googleListingUrl;
  }

  if (!directionsUrl) {
    return null;
  }

  return (
    <Row>
      <ArrowIconWrap>
        <Directions ariaHidden={true} />
      </ArrowIconWrap>
      <DirectionsLink href={directionsUrl} target="_blank" rel="noopener noreferrer">
        {t('address-directions-link-label')}
      </DirectionsLink>
      <ExternalIconWrap>
        <External ariaHidden={true} />
      </ExternalIconWrap>
    </Row>
  );
};

GetDirectionsLink.propTypes = {
  fields: PropTypes.shape({
    latitude: PropTypes.shape({
      value: PropTypes.string
    }),
    longitude: PropTypes.shape({
      value: PropTypes.string
    }),
    googleListing: PropTypes.shape({
      value: PropTypes.shape({
        href: PropTypes.string
      })
    })
  })
};

export default GetDirectionsLink;
